(function ($) {
  Drupal.behaviors.loyaltyGridFormatterV1 = {
    attached: false,
    attach: function (context, reset) {
      var setReset = reset || false;

      if (setReset) {
        this.attached = false;
      }

      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-loyalty-grid-formatter-v1', context);
      var $chkTier = $('.js-loyalty-grid-formatter__checkbox', $template);

      $chkTier.each(function (index) {
        var $this = $(this);

        $('.js-tier' + index).css('background-color', $this.css('background-color'));
      });
    }
  };
})(jQuery);
